import React from 'react';
import { DocumentationFile } from '../../../../graphql/graphql';
import ECardListItem from './ECardListItem';
import { FileToShare } from '../ECard/ECard';
import styles from './ECardList.module.scss';
import { ECardType } from '../../Enums/ECardType.enum';

interface Props {
	items: DocumentationFile[];
	reloadData: (folderId: string, needReload: boolean) => void;
	isShareMode: boolean;
	onItemCheck: (file: FileToShare, isChecked: boolean) => void;
	filesToShare: FileToShare[];
	eCardType: ECardType;
}

const ECardList: React.FC<Props> = ({
	items,
	reloadData,
	isShareMode,
	onItemCheck,
	filesToShare,
	eCardType,
}) => {
	return (
		<div className={styles.wrapper}>
			{items?.map(item => (
				<React.Fragment key={item.id}>
					<ECardListItem
						item={item}
						reloadData={reloadData}
						isShareMode={isShareMode}
						onCheck={onItemCheck}
						isSelected={filesToShare.some(file => file.id === item.id)}
						canBeEdited={eCardType === ECardType.HEALTH_DOCUMENTATION}
						eCardType={eCardType}
					/>
				</React.Fragment>
			))}
		</div>
	);
};

export default ECardList;
